import window from "global";
import React, { Component, useState } from "react";
import { useMutation } from "@apollo/client";
import { UPDATE_SETTINGS } from "@ugg/shared/api/graphql/queries";
import { TIER_LIST_OPTIONS } from "@ugg/shared/query-params/filter-options/tier-lists/tier-list";
import { validParams } from "@ugg/shared/query-params/valid-params";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import QueueType from "@ugg/shared/components/FilterManager/filters/QueueType";
import Rank from "@ugg/shared/components/FilterManager/filters/Rank";
import Region from "@ugg/shared/components/FilterManager/filters/Region";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";

const BuildsAndRunes = (props) => {
  const { userSettings, refetchQueries, setSettingsNotification } = props;
  const { filterDefaults } = userSettings;
  const { filterBuildsAndRunes } = filterDefaults;

  const setMissingDefaultValues = (filters) => {
    let newFilters = { ...filters };
    delete newFilters.__typename;

    const defaultParams = validParams[CHAMPION_PAGES.OVERVIEW].default;
    for (let [key, value] of Object.entries(defaultParams)) {
      if (key === "region") {
        if (!filters["regionId"]) {
          newFilters["regionId"] = value;
        }
      } else if (key === "rank") {
        if (!filters["mmr"]) {
          newFilters["mmr"] = value;
        }
      } else if (key === "queueType") {
        if (!filters[key]) {
          newFilters[key] = value;
        }
      }
    }

    return newFilters;
  };

  const [newFilterDefaults, setNewFilterDefaults] = useState(setMissingDefaultValues(filterBuildsAndRunes));

  const [updateSettings, { loading, data, error }] = useMutation(UPDATE_SETTINGS, {
    variables: {
      filterBuildsAndRunes: newFilterDefaults,
    },
    refetchQueries,
    onCompleted: (data) => {
      setSettingsNotification(true);
      window && window.scrollTo(0, 0);
    },
    onError: (error) => {
      setSettingsNotification(false);
    },
  });

  const onFilterChange = (type, value) => {
    if (type === "region") {
      setNewFilterDefaults({ ...newFilterDefaults, regionId: value.value });
    } else if (type === "queueType") {
      let newValue = {
        queueType: value.value,
      };

      if (
        value.value === "normal_aram" ||
        value.value === "nexus_blitz" ||
        value.value === "normal_blind_5x5" ||
        value.value === "normal_draft_5x5" ||
        value.value === "one_for_all"
      ) {
        newValue["mmr"] = "overall";
      } else {
        newValue["mmr"] = "emerald_plus";
      }

      setNewFilterDefaults({ ...newFilterDefaults, ...newValue });
    } else if (type === "rank") {
      setNewFilterDefaults({ ...newFilterDefaults, mmr: value.value });
    }
  };

  let filterProps = {
    filters: newFilterDefaults,
    onFilterChange,
  };

  return (
    <div className="settings-section email-subscriptions">
      <div className="section-content">
        <HeaderBullet className="mb-[24px]">Champion Statistics</HeaderBullet>
        <div className="field-group">
          <div className="field-label _with-helper-text">{"Default Region"}</div>
          <div className="settings_helper_text">{"Change to your preferred region for recommended builds."}</div>
          <div className="settings-filter-container">
            <Region {...filterProps} options={TIER_LIST_OPTIONS.region} disableTooltip />
          </div>
        </div>
        <div className="field-group">
          <div className="field-label _with-helper-text">{"Default Queue Type"}</div>
          <div className="settings_helper_text">
            {"Play only ARAM? Care only about the Normal Blind meta? Change to your main queue type."}
          </div>
          <div className="settings-filter-container">
            <QueueType {...filterProps} options={TIER_LIST_OPTIONS.queueType} disableTooltip />
          </div>
        </div>
        <div className="field-group">
          <div className="field-label _with-helper-text">{"Default Rank"}</div>
          <div className="settings_helper_text">
            {
              "If you're in Iron and only care about Iron and not the hoity toity Platinum Plus players, this is the setting for you."
            }
          </div>
          <div className="settings-filter-container">
            <Rank {...filterProps} options={TIER_LIST_OPTIONS.rank} disableTooltip disableByQueueType />
          </div>
        </div>
        <ButtonSuccess
          className="save-settings-btn btn-light-blue"
          label="Save Changes"
          isLoading={loading}
          onClick={updateSettings}
        />
      </div>
    </div>
  );
};

export default BuildsAndRunes;
